import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { collection, doc, getDoc, query, where } from 'firebase/firestore';
import { onSnapshot } from '../utils/firestoreListen';

const mentorsSnapshotKey = (uid) => `mentors:dashboard:${uid || 'anon'}`;

export default function Mentors() {
  const [profile, setProfile] = useState(null);
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;
    try {
      const raw = sessionStorage.getItem(mentorsSnapshotKey(uid));
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.profile) setProfile(parsed.profile);
        if (Array.isArray(parsed?.invites)) setInvites(parsed.invites);
      }
    } catch (_) {}
    const userRef = doc(db, 'users', uid);
    getDoc(userRef).then(s => { setProfile(s.exists()?s.data():null); setLoading(false); });
    const qRef = query(collection(db, 'mentorInvites'), where('ownerId','==', uid));
    const unsub = onSnapshot(qRef, snap => setInvites(snap.docs.map(d=>({ id:d.id, ...d.data() }))), undefined, { purpose: 'Mentors-invites', component: 'Mentors' });
    return () => unsub();
  }, []);
  
  useEffect(() => {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;
    try {
      sessionStorage.setItem(mentorsSnapshotKey(uid), JSON.stringify({ profile, invites }));
    } catch (_) {}
  }, [profile, invites]);

  const seatsPurchased = Number(profile?.mentorSeatsPurchased || 0);
  const seatsUsed = Number(profile?.mentorSeatsUsed || 0);
  const seatsRemaining = Math.max(0, seatsPurchased - seatsUsed);

  return (
    <div className="max-w-3xl mx-auto p-6">
      {loading && (
        <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
          Refreshing mentor data...
        </div>
      )}
      <h1 className="text-2xl font-bold text-amber-900 mb-2">Mentors</h1>
      <div className="text-sm text-amber-700 mb-4">Seats: {seatsUsed}/{seatsPurchased} used • Remaining: {seatsRemaining}</div>
      <div className="rounded-xl border border-amber-200 bg-white p-4">
        <h2 className="font-semibold text-amber-900 mb-2">Invites</h2>
        {invites.length === 0 ? (
          <div className="text-slate-600 text-sm">No mentor invites yet.</div>
        ) : (
          <ul className="list-disc ml-5 text-slate-800">
            {invites.map(i => (
              <li key={i.id}>{i.email} — <span className="text-slate-600">{i.status || 'pending'}</span></li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}




